<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        {{ $translate('materials') | capitalize }}
      </h1>
      <b-tabs position="" class="blocks" vertical>
        <b-tab-item
          v-for="material in $availableMaterials[module]"
          :key="material"
          :label="$translate(material) | capitalize"
          v-bind:materialtext="material"
        >
          <GeneralTableMaterial :materialtext="material" :module="module" :can-manage="canManage" />
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import GeneralTableMaterial from './components/GeneralTableMaterial'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'addMaterial',
  mixins: [permissionMixin],
  props: ['module'],
  components: {
    GeneralTableMaterial,
  },
  computed: {
    canManage() {
      return (
        this.userInfo.type === 'A' ||
        (this.userInfo.type === 'I' && (this.userInfo.level === 'S' || this.userInfo.level === '2'))
      )
    },
  },
  mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'A':
        isAllowed = true
        break
      case 'I':
        isAllowed = true
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')
  },
}
</script>
